<div class="header box-white-04">
  <div class="header-heading">
    <app-game-icon [game]="'Coinflip'"></app-game-icon>
    <h1 class="typography-title">coinflip</h1>
  </div>
  <div class="header-total-price">
    <app-cost [cost]="deprecatedCoinflipService.totalValue()" />
  </div>
  <div class="divider vertical h-full"></div>
  <div class="header-total">
    <span class="typography-small-title">{{
      deprecatedCoinflipService.totalItems()
    }}</span>
    <span class="typography-small">total items</span>
  </div>
  <div class="divider vertical h-full"></div>
  <div class="header-joinable">
    <span class="typography-small-title" style="color: var(--yellow)">{{
      deprecatedCoinflipService.joinableCount()
    }}</span>
    <span class="typography-small">joinable Coinflips</span>
  </div>
  <div class="divider vertical h-full"></div>
  <div class="header-total-coinflips">
    <span class="typography-small-title">{{
      deprecatedCoinflipService.games().length
    }}</span>
    <span class="typography-small">Total Coinflips</span>
  </div>
  <app-fairness-button
    class="header-fairness"
    href="/provably-fair/coinflip"
  ></app-fairness-button>
  <div class="divider vertical h-full"></div>
  <div class="header-created">
    <span class="typography-small-title"
      >{{ deprecatedCoinflipService.myOpenedGames().length }}/5</span
    >
    <span class="typography-small">games created</span>
  </div>
  <div class="divider vertical h-full"></div>
  <div class="header-my-value">
    <app-cost [cost]="deprecatedCoinflipService.myOpenedGamesSum()" />
    <span class="typography-small">Total Value</span>
  </div>
  <div class="divider vertical h-full"></div>
  <button
    class="create button button--style-yellow padding-x-12 h-36"
    style="--button-height: 40px"
    (click)="openCreateGame()"
  >
    <app-game-icon icon [game]="'Coinflip'" color="black"></app-game-icon>
    Create Coinflip
  </button>
</div>
